import { Interop_reactApi } from "../fable_modules/Feliz.1.57.0/Interop.fs.js";
import { empty, cons, singleton, ofArray } from "../fable_modules/fable-library.3.6.3/List.js";
import { createElement } from "react";
import { createObj } from "../fable_modules/fable-library.3.6.3/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { Msg } from "./Update.js";
import { IncludePos, DownloadFormat } from "../Shared/fs/Shared.js";
import { interpolate, toText } from "../fable_modules/fable-library.3.6.3/String.js";
import { empty as empty_1, map, toArray, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library.3.6.3/Seq.js";
import { value as value_251 } from "../fable_modules/fable-library.3.6.3/Option.js";

export function navbar(_model, _dispatch) {
    let elms, props, children_2, elms_1, props_4, props_7;
    const props_11 = ofArray([["className", "is-fixed-top"], ["className", "has-shadow"], ["className", "is-info"], ["children", Interop_reactApi.Children.toArray([(elms = singleton((props = ofArray([["style", {
        fontSize: 20 + "px",
    }], ["children", "Oslo-Bergen-taggeren på nett"]]), createElement("div", createObj(Helpers_combineClasses("navbar-item", props))))), createElement("div", {
        className: "navbar-brand",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), (children_2 = singleton((elms_1 = ofArray([(props_4 = ofArray([["href", "https://www.hf.uio.no/iln/tjenester/kunnskap/sprak/ob-tagger/index.html"], ["target", "_blank"], ["children", Interop_reactApi.Children.toArray([createElement("img", {
        src: "obt5-liten.png",
    })])]]), createElement("a", createObj(Helpers_combineClasses("navbar-item", props_4)))), (props_7 = ofArray([["href", "https://www.hf.uio.no/iln/om/organisasjon/tekstlab/"], ["target", "_blank"], ["children", Interop_reactApi.Children.toArray([createElement("img", {
        src: "logo.png",
    })])]]), createElement("a", createObj(Helpers_combineClasses("navbar-item", props_7))))]), createElement("div", {
        className: "navbar-end",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    }))), createElement("div", {
        className: "navbar-menu",
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    }))])]]);
    return createElement("nav", createObj(Helpers_combineClasses("navbar", props_11)));
}

export function view(model, dispatch) {
    let elms_2, elms_1, elms, matchValue_1, elms_5, elms_3, elms_4, elms_6, s_2, elms_7, children_7, children_9, children_11, value_203, value_204, value_205, value_206, value_207, value_208, value_209, value_210, elms_17, elms_15, elms_16, props_90, matchValue_3, contentHash, children_39, elms_10, elm_6, elms_11, children_26, props_49, children_28, elm_9, elms_13, elms_12, children_33, props_60, children_35, props_63, props_92;
    let displayedFilename;
    const matchValue = model.Filename;
    displayedFilename = ((matchValue == null) ? "Ingen fil valgt" : matchValue);
    let textSelector;
    const props_8 = ofArray([["className", "has-name"], ["children", Interop_reactApi.Children.toArray([(elms_2 = ofArray([createElement("input", createObj(cons(["type", "file"], Helpers_combineClasses("file-input", ofArray([["onChange", (ev) => {
        const files = ev.target.files;
        if ((!(files == null)) && (files.length > 0)) {
            dispatch(new Msg(0, files.item(0)));
        }
    }], ["accept", "text/plain"]]))))), (elms_1 = ofArray([(elms = singleton(createElement("i", {
        className: "fas fa-upload",
    })), createElement("span", {
        className: "file-icon",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), createElement("div", {
        className: "field-label",
        children: "Velg tekstfil...",
    })]), createElement("span", {
        className: "file-cta",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    })), createElement("span", {
        className: "file-name",
        children: displayedFilename,
    })]), createElement("label", {
        className: "file-label",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    }))])]]);
    textSelector = createElement("div", createObj(Helpers_combineClasses("file", props_8)));
    let taggingIndicator;
    const props_17 = ofArray([["style", {
        marginTop: 20,
    }], ["children", Interop_reactApi.Children.toArray(Array.from((matchValue_1 = model.TaggingStatus, (matchValue_1.tag === 1) ? singleton((elms_5 = ofArray([(elms_3 = singleton(createElement("div", {
        className: "loader",
        style: {
            fontSize: 3 + "px",
            margin: 0,
        },
        children: "Tagger tekst...",
    })), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
    })), (elms_4 = singleton(createElement("div", {
        children: ["Tagger tekst..."],
    })), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
    }))]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_5)),
    }))) : ((matchValue_1.tag === 2) ? singleton((elms_6 = singleton((s_2 = (`Ferdig med å tagge ${model.Filename}`), createElement("div", {
        className: "level-item",
        children: s_2,
    }))), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_6)),
    }))) : empty()))))]]);
    taggingIndicator = createElement("nav", createObj(Helpers_combineClasses("level", props_17)));
    let lemmaDownloadButtons;
    const elm_3 = [(elms_7 = ofArray([createElement("div", {
        className: "level-item",
        children: "Last ned:",
    }), (children_7 = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg1) => {
        dispatch(new Msg(6, new DownloadFormat(0)));
    }], ["children", "Excel"]]))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_7)),
    })), (children_9 = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg2) => {
        dispatch(new Msg(6, new DownloadFormat(1)));
    }], ["children", "Tabseparert"]]))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_9)),
    })), (children_11 = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg3) => {
        dispatch(new Msg(6, new DownloadFormat(2)));
    }], ["children", "Kommaseparert"]]))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_11)),
    }))]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_7)),
    }))];
    lemmaDownloadButtons = createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_3)),
    });
    let textInfo;
    const matchValue_2 = model.TaggedTextInfo;
    if (matchValue_2 == null) {
        textInfo = null;
    }
    else {
        const ti = matchValue_2;
        const elms_14 = ofArray([(value_203 = (`Alle tokens: ${ti.NumAllTokens}`), createElement("div", {
            children: [value_203],
        })), (value_204 = (`Ordformer (alle tokens - tegnsetting): ${ti.NumWordTokens}`), createElement("div", {
            children: [value_204],
        })), (value_205 = (`Ordtyper (forskjellige ordformer): ${ti.NumWordTypes}`), createElement("div", {
            children: [value_205],
        })), (value_206 = toText(interpolate("Ordtyper/ordformer: %.2f%P()", [ti.NumWordTypes / ti.NumWordTokens])), createElement("div", {
            children: [value_206],
        })), (value_207 = (`Ordlemmatyper (forskjellige ordlemmaer): ${ti.NumWordLemmaTypes}`), createElement("div", {
            children: [value_207],
        })), (value_208 = toText(interpolate("Ordlemmatyper/ordlemmaer: %.2f%P()", [ti.NumWordLemmaTypes / ti.NumWordTokens])), createElement("div", {
            children: [value_208],
        })), (value_209 = toText(interpolate("Gjennomsnittlig ordlengde: %.2f%P()", [ti.AvgWordLength])), createElement("div", {
            children: [value_209],
        })), (value_210 = toText(interpolate("Gjennomsnittlig setningslengde: %.2f%P()", [ti.AvgSentenceLength])), createElement("div", {
            children: [value_210],
        }))]);
        textInfo = createElement("div", {
            className: "box",
            children: Interop_reactApi.Children.toArray(Array.from(elms_14)),
        });
    }
    const children_45 = ofArray([navbar(model, dispatch), (elms_17 = ofArray([(elms_15 = ofArray([createElement("span", {
        children: ["Last opp en fil i txt-format (utf-8) og få den morfologisk tagga med "],
    }), createElement("a", {
        href: "https://www.hf.uio.no/iln/tjenester/kunnskap/sprak/ob-tagger/index.html",
        target: "_blank",
        style: {
            color: "#485fc7",
            textDecoration: "none",
        },
        children: "Oslo-Bergen-taggeren for bokmål",
    }), createElement("span", {
        children: ["."],
    }), createElement("span", {
        children: [" Resultatet kan lastes ned eller vises i "],
    }), createElement("a", {
        href: "https://voyant-tools.org/",
        target: "_blank",
        style: {
            color: "#485fc7",
            textDecoration: "none",
        },
        children: "Voyant",
    }), createElement("span", {
        children: ["."],
    }), createElement("br", {}), createElement("span", {
        children: [" Du kan også få en oversikt over alle lemmaer i teksten, få gjennomsnittlig ordlengde og setningslengde mm."],
    }), createElement("br", {}), createElement("b", {
        children: ["NB!"],
    }), createElement("span", {
        children: [" Teksten kan være på maks 1MB, og store tekster kan ta opptil tre minutter å tagge."],
    })]), createElement("div", {
        className: "notification",
        children: Interop_reactApi.Children.toArray(Array.from(elms_15)),
    })), (elms_16 = ofArray([(props_90 = singleton(["children", Interop_reactApi.Children.toArray([textSelector, taggingIndicator, textInfo, (matchValue_3 = model.TaggedTextInfo, (matchValue_3 == null) ? null : ((contentHash = matchValue_3.ContentHash.fields[0], (children_39 = ofArray([(elms_10 = ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg4) => {
        dispatch(new Msg(2));
    }], ["children", "Last ned tagga tekst"]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg5) => {
        dispatch(new Msg(4));
    }], ["children", "Vis lemmaer"]]))))]), createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(elms_10)),
    })), (elm_6 = [(elms_11 = ofArray([createElement("div", {
        className: "level-item",
        children: "Last ned lemmatisert tekst:",
    }), (children_26 = singleton((props_49 = ofArray([["className", "is-info"], ["style", {
        marginLeft: 38,
    }], ["onClick", (_arg6) => {
        dispatch(new Msg(8, new IncludePos(0, true)));
    }], ["children", "Med ordklasser"]]), createElement("button", createObj(Helpers_combineClasses("button", props_49))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_26)),
    })), (children_28 = singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg7) => {
        dispatch(new Msg(8, new IncludePos(0, false)));
    }], ["children", "Uten ordklasser"]]))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_28)),
    }))]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_11)),
    }))], createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_6)),
    })), (elm_9 = [(elms_13 = ofArray([(elms_12 = ofArray([createElement("span", {
        children: ["Åpne lemmatisert tekst i"],
    }), createElement("a", {
        style: {
            marginLeft: 5,
        },
        href: "https://voyant-tools.org/",
        target: "_blank",
        children: "Voyant:",
    })]), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_12)),
    })), (children_33 = singleton((props_60 = ofArray([["className", "is-info"], ["href", `https://voyant.lincsproject.ca/?input=https://tekstlab.uio.no/obt_nett/rest/lemmatized_text/1/${contentHash}`], ["target", "_blank"], ["children", "Med ordklasser"]]), createElement("a", createObj(Helpers_combineClasses("button", props_60))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_33)),
    })), (children_35 = singleton((props_63 = ofArray([["className", "is-info"], ["href", `https://voyant.lincsproject.ca/?input=https://tekstlab.uio.no/obt_nett/rest/lemmatized_text/0/${contentHash}`], ["target", "_blank"], ["children", "Uten ordklasser"]]), createElement("a", createObj(Helpers_combineClasses("button", props_63))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_35)),
    }))]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_13)),
    }))], createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_9)),
    }))]), createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_39)),
    })))))])]), createElement("div", createObj(Helpers_combineClasses("column", props_90)))), (props_92 = ofArray([["style", {
        marginLeft: 20,
    }], ["children", Interop_reactApi.Children.toArray(Array.from(toList(delay(() => ((model.Lemmas != null) ? append(singleton_1(lemmaDownloadButtons), delay(() => {
        let lemmas, header, children_17, children_15, body, children_21, elms_9;
        return singleton_1((lemmas = value_251(model.Lemmas), (header = ((children_17 = singleton((children_15 = ofArray([createElement("td", {
            children: ["Frekvens"],
        }), createElement("td", {
            children: ["Lemma"],
        }), createElement("td", {
            children: ["Ordklasse"],
        })]), createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children_15)),
        }))), createElement("thead", {
            children: Interop_reactApi.Children.toArray(Array.from(children_17)),
        }))), (body = ((children_21 = toArray(delay(() => map((lemma) => {
            const children_19 = ofArray([createElement("td", {
                style: {
                    textAlign: "right",
                },
                children: lemma.Frequency,
            }), createElement("td", {
                children: [lemma.Form],
            }), createElement("td", {
                children: [lemma.Pos],
            })]);
            return createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children_19)),
            });
        }, lemmas))), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_21)),
        }))), (elms_9 = singleton(createElement("table", {
            className: "table",
            children: Interop_reactApi.Children.toArray([header, body]),
        })), createElement("div", {
            className: "table-container",
            children: Interop_reactApi.Children.toArray(Array.from(elms_9)),
        }))))));
    })) : empty_1())))))]]), createElement("div", createObj(Helpers_combineClasses("column", props_92))))]), createElement("div", {
        className: "columns",
        children: Interop_reactApi.Children.toArray(Array.from(elms_16)),
    }))]), createElement("section", {
        className: "section",
        children: Interop_reactApi.Children.toArray(Array.from(elms_17)),
    }))]);
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_45)),
    });
}

